import { TranslateModule } from '@ngx-translate/core';
import { SalleComponent } from './salle/salle.component';
import { CultureComponent } from './culture/culture.component';
import { TacheModule } from './tache/tache.module';
import { NgModule } from '@angular/core';
import { PagesComponent } from './pages.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { PagesRoutingModule } from './pages-routing.module';
import { ThemeModule } from '../@theme/theme.module';
import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';
import { RecetteModule } from './recette/recette.module';
import { NbAccordionModule } from '@nebular/theme';
import { ParamModule } from './parametre/param.module';

const PAGES_COMPONENTS = [
  PagesComponent,
  CultureComponent,
  SalleComponent
];
const ENTRY_COMPONENTS = [
];

@NgModule({
  imports: [
    PagesRoutingModule,
    ThemeModule,
    DashboardModule,
    NbAccordionModule,
    RecetteModule,
    ParamModule,
    TacheModule,
    MiscellaneousModule,
  ],
  declarations: [
    ...PAGES_COMPONENTS,
  ],
  entryComponents: [
    ...ENTRY_COMPONENTS,
  ],
})
export class PagesModule {
}
